
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoInvoiceReceiveAppEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoInvoiceReceiveAppRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoInvoiceReceiveAppRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
